import { I18n } from "@assets/strings";
import React from "react";
import { useSuggestedQuizzes } from "@domain/lms/quiz/hooks";
import { Carousel } from "@ui/components/carousel/carousel";
import { QuizThumbnail } from "@ui/components/quiz/quizThumbnail";

type FeedQuizSuggestionsProps = React.HTMLAttributes<HTMLDivElement>;
export const FeedQuizSuggestions: React.FC<FeedQuizSuggestionsProps> = ({ ...htmlProps }) => {
	const { result: quizzes, loading } = useSuggestedQuizzes(5);

	return (
		<Carousel
			{...htmlProps}
			style={{ marginTop: 20 }}
			items={quizzes ?? []}
			renderItem={(quiz) => <QuizThumbnail key={quiz.id} quiz={quiz} small />}
			title={I18n.t("feed.suggestions.quizzes")}
			loading={loading}
		/>
	);
};
